import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { PerfilService } from '../../../services/ajs-perfil.service';

@Component({
  selector: 'mandae-integration-setup-display-api-token',
  templateUrl: './integration-setup-display-api-token.component.html',
  styleUrls: ['./integration-setup-display-api-token.component.scss', '../integration-setup-dialog.shared.scss']
})
export class IntegrationSetupDisplayApiTokenComponent implements OnInit {

  apiToken: string;

  @Input() stepCount = 0;
  @Input() stepNumber = 0;

  constructor(private perfilService: PerfilService, private snackBar: MatSnackBar) { }

  async ngOnInit() {
    try {
      const data = await this.perfilService.getToken();
      this.apiToken = data.token;
    } catch (e) {
      this.snackBar.open('Não foi possível obter os dados da API', 'OK');
    }
  }

}
